// Mock data for Hearthlowe website

export const recipes = [
  {
    id: 1,
    title: "Simple Sourdough Loaf",
    difficulty: "Beginner",
    time: "24 hours",
    image: "https://images.unsplash.com/photo-1654524086749-aa2703ab0784?auto=format&fit=crop&w=1200&q=80",
    ingredients: [
      "400g bread flour",
      "100g active sourdough starter",
      "300g water",
      "10g salt"
    ],
    instructions: [
      "Mix flour and water, let rest 30 minutes (autolyse)",
      "Add starter and salt, mix until combined",
      "Perform stretch and folds every 30 minutes for 2-3 hours",
      "Shape and place in banneton basket",
      "Refrigerate overnight (12-18 hours)",
      "Score and bake at 450°F for 45 minutes"
    ],
    tags: ["beginner-friendly", "classic", "overnight"]
  },
  {
    id: 2,
    title: "Low-Effort Sourdough Loaf",
    difficulty: "Beginner",
    time: "18 hours",
    image: "https://images.unsplash.com/photo-1728026918148-72bc0420373c?auto=format&fit=crop&w=1200&q=80",
    ingredients: [
      "500g all-purpose flour",
      "100g active starter",
      "350g water",
      "10g salt"
    ],
    notes: [
      "‘Low-effort’ means no long kneading session. You’ll still mix well at the start to fully hydrate the flour.",
      "A few gentle folds are the difference between a loaf that spreads and a loaf that rises—especially with all-purpose flour.",
      "Use the dough’s feel (strength and bubbles) more than the clock: warmer kitchens ferment faster."
    ],
    instructions: [
      "Mix flour and water until no dry bits remain; rest 20–30 minutes",
      "Add starter and salt; mix thoroughly (whisk/scraper/hands) until evenly combined",
      "Over the next 90 minutes, do 2–3 gentle stretch & folds (every 30–45 minutes)",
      "Let dough bulk ferment until slightly domed and aerated (typically 3–6 hours depending on temperature)",
      "Shape gently and place in banneton; refrigerate overnight (8–14 hours)",
      "Score and bake at 450°F for ~40–45 minutes (covered first, then uncovered to brown)"
    ],
    tags: ["beginner-friendly", "low-effort", "easy"]
  },
  {
    id: 3,
    title: "Sourdough Discard Pancakes",
    difficulty: "Beginner",
    time: "15 minutes",
    image: "https://images.unsplash.com/photo-1528207776546-365bb710ee93?auto=format&fit=crop&w=1200&q=80",
    ingredients: [
      "1 cup sourdough discard",
      "1 egg",
      "2 tbsp sugar",
      "2 tbsp melted butter",
      "1/2 tsp baking soda",
      "Pinch of salt"
    ],
    instructions: [
      "Mix all ingredients until smooth",
      "Heat griddle to medium heat",
      "Pour batter and cook until bubbles form",
      "Flip and cook until golden",
      "Serve with maple syrup"
    ],
    tags: ["beginner-friendly", "quick", "discard-recipe"]
  },
  {
    id: 4,
    title: "Rustic Country Loaf",
    difficulty: "Intermediate",
    time: "30 hours",
    image: "https://images.unsplash.com/photo-1612136435623-a9bb63231e07?auto=format&fit=crop&w=1200&q=80",
    ingredients: [
      "450g bread flour",
      "50g whole wheat flour",
      "100g active starter",
      "350g water",
      "12g salt"
    ],
    instructions: [
      "Mix flours and water, autolyse 1 hour",
      "Add starter and salt, mix thoroughly",
      "Bulk ferment with stretch and folds every 30 min for 4 hours",
      "Shape and proof in banneton",
      "Cold ferment 18-24 hours",
      "Score and bake in Dutch oven at 475°F"
    ],
    tags: ["whole-grain", "overnight", "artisan"]
  },
  {
    id: 5,
    title: "Sourdough English Muffins",
    difficulty: "Beginner",
    time: "Overnight + 20 minutes",
    image: "https://images.unsplash.com/photo-1703015640380-9408ac6e42ac?auto=format&fit=crop&w=1200&q=80",
    ingredients: [
      "240g all-purpose flour",
      "120g sourdough starter (active or discard)",
      "120g milk (or water)",
      "15g honey (optional)",
      "5g salt",
      "1/2 tsp baking soda (added right before cooking)"
    ],
    instructions: [
      "Mix flour, starter, milk, honey, and salt; cover and rest overnight",
      "In the morning, gently mix in baking soda",
      "Spoon dough onto a lightly greased skillet (or use rings)",
      "Cook on low until set and golden, then flip",
      "Cool, then fork-split for best nooks and crannies"
    ],
    tags: ["beginner-friendly", "discard-recipe", "breakfast"]
  },
  {
    id: 6,
    title: "Easy Sourdough Focaccia",
    difficulty: "Beginner",
    time: "Same day",
    image: "https://images.unsplash.com/photo-1706145787429-4d6b00a5dc0c?auto=format&fit=crop&w=1200&q=80",
    ingredients: [
      "400g bread flour (or all-purpose)",
      "100g active starter",
      "300g water",
      "10g salt",
      "30g olive oil"
    ],
    instructions: [
      "Mix flour, water, starter; rest 30 minutes",
      "Add salt and a drizzle of olive oil; fold a few times over 2 hours",
      "Bulk rise until puffy (3–5 hours depending on temp)",
      "Oil a pan, stretch dough gently into the pan",
      "Dimple, add toppings, and bake until golden"
    ],
    tags: ["beginner-friendly", "same-day", "snack"]
  },
  {
    id: 7,
    title: "Sourdough Crackers",
    difficulty: "Beginner",
    time: "45 minutes",
    image: "https://images.unsplash.com/photo-1615294209152-571969a7fbfe?auto=format&fit=crop&w=1200&q=80",
    ingredients: [
      "200g sourdough discard",
      "30g melted butter (or olive oil)",
      "1/2 tsp salt",
      "Optional: sesame seeds, everything seasoning, rosemary"
    ],
    instructions: [
      "Mix discard, fat, salt, and any seasonings",
      "Spread very thin on parchment-lined sheet pan",
      "Bake until set, then score and continue baking until crisp",
      "Cool completely for maximum crunch"
    ],
    tags: ["beginner-friendly", "discard-recipe", "quick"]
  },
  {
    id: 8,
    title: "Simple Sourdough Pizza Dough",
    difficulty: "Beginner",
    time: "Same day or overnight",
    image: "https://images.unsplash.com/photo-1537734796389-e1fc293cf856?auto=format&fit=crop&w=1200&q=80",
    ingredients: [
      "400g bread flour (or all-purpose)",
      "80g active starter",
      "260g water",
      "10g salt",
      "10g olive oil (optional)"
    ],
    instructions: [
      "Mix ingredients until combined; rest 30 minutes",
      "Stretch and fold 2–3 times over 90 minutes",
      "Bulk until airy (3–6 hours), or cold-proof overnight",
      "Portion into balls, rest 30 minutes",
      "Stretch, top, and bake hot (475–550°F if possible)"
    ],
    tags: ["beginner-friendly", "same-day", "family"]
  }
];

export const dictionaryTerms = [
  {
    term: "Active Starter",
    definition: "A starter that's bubbly, risen, and ready to bake with. You'll know it's active when it has doubled in size, has a domed top, and is full of bubbles throughout. This is the ideal state for baking."
  },
  {
    term: "Autolyse",
    definition: "A resting period where flour and water are mixed together before adding starter and salt. This allows the flour to fully hydrate and gluten to begin developing naturally, resulting in better dough structure and easier handling."
  },
  {
    term: "Banneton",
    definition: "A basket (usually rattan) lined with linen, used to support dough during its final proof. The basket's shape helps the dough maintain structure and creates beautiful patterns on the crust."
  },
  {
    term: "Bench Rest",
    definition: "A short rest period (typically 15-30 minutes) during the shaping process. This allows the gluten to relax, making the final shaping easier and preventing the dough from tearing."
  },
  {
    term: "Blistering",
    definition: "Small bubbles that appear on the crust, especially when dough has been cold-proofed in the refrigerator. These create a beautiful, artisan appearance and indicate proper fermentation."
  },
  {
    term: "Bloom",
    definition: "How much the loaf opens and expands while baking, particularly where you've scored it. Good bloom indicates proper fermentation, shaping, and scoring technique."
  },
  {
    term: "Bulk Fermentation",
    definition: "The first rise of your dough after mixing all ingredients. During this phase, the dough develops flavor and structure. For sourdough, this typically takes 3-5 hours at room temperature."
  },
  {
    term: "Coil Fold",
    definition: "A gentle folding technique where you lift the dough from the center and tuck it underneath itself, rotating the bowl to repeat on all sides. This builds strength without degassing the dough too much."
  },
  {
    term: "Cold Proof",
    definition: "Proofing (final rise) your shaped dough in the refrigerator, typically overnight. This slows fermentation, develops deeper flavor, makes scoring easier, and creates better crust blistering."
  },
  {
    term: "Crumb",
    definition: "The internal structure of your bread - the pattern of holes and texture you see when you slice it open. An open crumb has large irregular holes, while a tight crumb is more uniform."
  },
  {
    term: "Crust",
    definition: "The outer layer of the bread that forms during baking. A good sourdough crust should be crispy, golden-brown, and deeply caramelized with a satisfying crunch."
  },
  {
    term: "Discard",
    definition: "The portion of starter removed before feeding to control volume and keep your starter manageable. Rather than throwing it away, discard can be used in pancakes, crackers, waffles, and other recipes."
  },
  {
    term: "Dutch Oven Bake",
    definition: "Baking bread in a covered Dutch oven or similar vessel. The lid traps steam, which helps the bread rise dramatically and develop a beautiful, crispy crust."
  },
  {
    term: "Ear",
    definition: "The raised, crispy flap of crust that forms along your score line when bread is baked properly. A pronounced ear is a sign of good technique and proper oven spring."
  },
  {
    term: "Feeding",
    definition: "Refreshing your starter by discarding a portion and adding fresh flour and water. This keeps the yeast active and healthy. A typical feeding ratio is 1:1:1 (starter:flour:water)."
  },
  {
    term: "Fed Starter",
    definition: "Starter that has recently been refreshed with fresh flour and water. It will be at its most active 4-12 hours after feeding, depending on temperature."
  },
  {
    term: "Final Shape",
    definition: "The last shaping step before placing dough in the banneton for its final proof. This is where you create the tension and structure needed for a good rise in the oven."
  },
  {
    term: "Gluten Development",
    definition: "The process of building strength and elasticity in dough. This happens through mixing, kneading, or folding techniques, and gives bread its structure and chew."
  },
  {
    term: "Hooch",
    definition: "The dark liquid (usually brown or gray) that forms on top of starter when it's very hungry and hasn't been fed in a while. It's alcohol produced by the yeast and is harmless - you can stir it back in or pour it off before feeding."
  },
  {
    term: "Hydration (of dough)",
    definition: "The ratio of water to flour in your dough, expressed as a percentage. For example, 500g flour + 375g water = 75% hydration. Higher hydration creates more open crumb but can be trickier to handle."
  },
  {
    term: "Hydration (of starter)",
    definition: "The ratio of water to flour in your starter. A 100% hydration starter has equal weights of flour and water. Different hydration levels affect how your starter behaves and performs."
  },
  {
    term: "Incorporation",
    definition: "The process of fully mixing all ingredients together so there are no dry bits of flour remaining. This is the first step after adding starter and salt to your autolyse."
  },
  {
    term: "Lame",
    definition: "A blade (usually a razor) mounted on a handle, used to score bread before baking. The sharp blade allows you to make clean cuts that control how the bread expands."
  },
  {
    term: "Levain",
    definition: "A small, specific build of starter made just for a particular recipe. It's essentially a very fresh, vigorous starter that gives you more control over your bread's flavor and timing."
  },
  {
    term: "Oven Spring",
    definition: "The dramatic rise that happens in the first 10-15 minutes of baking as gases expand rapidly from the heat. Good oven spring indicates proper fermentation and scoring."
  },
  {
    term: "Overproofed",
    definition: "Dough that has fermented too long and lost its structure. Overproofed dough won't rise much in the oven and may spread flat. The dough feels very soft and doesn't spring back when poked."
  },
  {
    term: "Overripe Starter",
    definition: "Starter that has passed its peak rise and started falling. It may smell very sour or like acetone. While still usable, it's not ideal for baking - better to feed it and wait for peak activity."
  },
  {
    term: "Peak",
    definition: "When your starter has reached maximum rise and activity, typically 4-12 hours after feeding depending on temperature. This is the ideal time to use it for baking - it should be domed on top and very bubbly."
  },
  {
    term: "Pre-shape",
    definition: "An initial, gentle shaping done before the bench rest and final shape. This creates some structure while keeping the dough relaxed enough for the final shape."
  },
  {
    term: "Proofing",
    definition: "The final rise after shaping your dough. This is when the dough is in the banneton basket. Proofing can be done at room temperature (2-4 hours) or in the refrigerator overnight for enhanced flavor."
  },
  {
    term: "Retardation",
    definition: "Slowing down fermentation by using cold temperatures (refrigeration). This technique develops deeper flavor and makes timing more flexible - you can bake when it's convenient for you."
  },
  {
    term: "Rise",
    definition: "The increase in dough volume during fermentation as yeast produces gas. In sourdough, you'll see multiple rises: bulk fermentation (first rise) and proofing (final rise). Look for a 50-75% increase during bulk fermentation."
  },
  {
    term: "Scoring",
    definition: "Making deliberate cuts on the dough surface before baking using a lame (razor blade). This controls where the bread expands and creates beautiful patterns."
  },
  {
    term: "Shaggy Dough",
    definition: "The rough, uneven appearance of dough right after initial mixing, before gluten has developed. Don't worry if it looks messy at this stage - that's completely normal!"
  },
  {
    term: "Slack Dough",
    definition: "Very loose, soft dough that's hard to shape and flows easily. This is common with high-hydration doughs (80%+). It requires different handling techniques but creates beautiful open crumb."
  },
  {
    term: "Starter",
    definition: "A living culture of wild yeast and beneficial bacteria that naturally ferment flour and water. Your starter is what makes sourdough bread rise and gives it its distinctive tangy flavor."
  },
  {
    term: "Steam",
    definition: "Moist heat in the oven during the first part of baking. Steam keeps the crust soft initially so the bread can expand fully, then you remove it to let the crust crisp up. Dutch ovens trap steam naturally."
  },
  {
    term: "Stretch and Fold",
    definition: "A gentle technique to build gluten strength without kneading. You lift one side of the dough and fold it over itself, rotating the bowl and repeating. This is done several times during bulk fermentation."
  },
  {
    term: "Tight Dough",
    definition: "Firm dough with strong structure that holds its shape well. Easier to handle and shape than slack dough, but may produce a tighter crumb structure."
  },
  {
    term: "Underfed Starter",
    definition: "Starter that hasn't received enough fresh flour and water to stay healthy and active. Signs include slow rising, very sour smell, and hooch formation. Solution: increase feeding frequency or feeding ratio."
  },
  {
    term: "Underproofed",
    definition: "Dough that hasn't fermented long enough before baking. It will have explosive oven spring but may have a dense crumb and torn crust. The dough feels very firm and springs back quickly when poked."
  },
  {
    term: "Windowpane Test",
    definition: "A test for gluten development where you stretch a small piece of dough thin. If it stretches into a translucent 'windowpane' without tearing, gluten is well-developed. If it tears easily, continue folding."
  }
];

export const troubleshooting = [
  {
    id: 1,
    issue: "My starter isn't bubbling",
    category: "Starter Issues",
    solutions: [
      "Be patient - new starters can take 7-14 days to become active",
      "Check temperature - starters thrive at 70-75°F",
      "Try feeding twice daily with 1:1:1 ratio",
      "Use filtered or bottled water if your tap water is heavily chlorinated",
      "Ensure you're using unbleached flour (bleach can inhibit fermentation)"
    ]
  },
  {
    id: 2,
    issue: "My dough is too sticky",
    category: "Dough Handling",
    solutions: [
      "Wet your hands instead of flouring them when handling dough",
      "Use the dough whisk from your kit instead of hands initially",
      "Give it more time - wet dough often becomes easier to handle as gluten develops",
      "For next batch, reduce water by 25g and adjust from there",
      "Use the bench scraper to help with handling sticky dough"
    ]
  },
  {
    id: 3,
    issue: "My bread didn't rise",
    category: "Baking Problems",
    solutions: [
      "Check if your starter was at peak activity when you used it",
      "Ensure proper bulk fermentation time - dough should increase 50-75% in size",
      "Verify oven temperature with an oven thermometer",
      "Don't skip the stretch and folds during bulk fermentation",
      "Make sure your kitchen isn't too cold (under 68°F slows fermentation significantly)"
    ]
  },
  {
    id: 4,
    issue: "Bread is too dense",
    category: "Baking Problems",
    solutions: [
      "Increase bulk fermentation time by 30-60 minutes",
      "Ensure you're not over-proofing (poke test: dough should slowly spring back)",
      "Try increasing hydration by 10-20g for next loaf",
      "Make sure your starter is very active and bubbly before using",
      "Perform more stretch and folds to develop gluten structure"
    ]
  },
  {
    id: 5,
    issue: "Crust is too thick or tough",
    category: "Baking Problems",
    solutions: [
      "Create steam in the oven - use a Dutch oven or pan of water",
      "Lower oven temperature by 25°F",
      "Brush loaf with butter immediately after baking",
      "Store bread in a bread box, not the refrigerator",
      "Reduce baking time by 5 minutes"
    ]
  },
  {
    id: 6,
    issue: "Starter smells like acetone or nail polish",
    category: "Starter Issues",
    solutions: [
      "This is normal when starter is very hungry - simply feed it",
      "Increase feeding frequency to twice daily",
      "Use a larger feeding ratio (1:2:2 or 1:3:3)",
      "Not a sign of contamination - completely safe to use after feeding"
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does it take to create a starter from scratch?",
    answer: "Creating a sourdough starter from scratch typically takes 7-14 days. You'll feed it daily with equal parts flour and water. By day 5-7, you should see consistent bubbling and rising. The starter is ready to use when it doubles in size within 4-12 hours after feeding."
  },
  {
    id: 2,
    question: "Can I use whole wheat or other flours?",
    answer: "Absolutely! Whole wheat, rye, and other whole grain flours actually ferment more readily than white flour. For beginners, we recommend starting with at least 80% bread flour and substituting up to 20% with whole grains. As you gain confidence, you can experiment with higher percentages."
  },
  {
    id: 3,
    question: "What if I can't bake every day?",
    answer: "Sourdough is very flexible! You can store your starter in the refrigerator and feed it just once a week. Before baking, take it out, feed it, and let it come to room temperature and peak activity (usually 8-12 hours). The cold fermentation method actually improves flavor."
  },
  {
    id: 4,
    question: "Do I need a Dutch oven?",
    answer: "While a Dutch oven creates excellent results by trapping steam, it's not required. You can bake directly on a baking stone or sheet pan and create steam by placing a pan of water on the bottom oven rack. The parchment paper in your kit helps with easy transfer."
  },
  {
    id: 5,
    question: "Why does my bread spread instead of rising up?",
    answer: "This usually indicates dough that's too wet, under-fermented, or lacking gluten development. Solutions: reduce water slightly, ensure adequate bulk fermentation time, perform more stretch and folds, and make sure you're shaping with enough tension."
  },
  {
    id: 6,
    question: "How do I know when my dough is ready to bake?",
    answer: "Use the 'poke test': gently press your finger into the dough. If it springs back slowly and leaves a slight indent, it's ready. If it springs back quickly, it needs more time. If it doesn't spring back at all, it may be over-proofed."
  },
  {
    id: 7,
    question: "Can I kill my starter?",
    answer: "Sourdough starters are remarkably resilient! As long as there's no mold (which is rare), you can revive a neglected starter. Even if it's been in the fridge for months, discard most of it, and start feeding it twice daily. Within 3-5 days, it should be active again."
  },
  {
    id: 8,
    question: "What temperature should my kitchen be?",
    answer: "Ideal temperature is 70-75°F (21-24°C). Warmer speeds up fermentation, cooler slows it down. In winter, place your starter near (not on) a heating vent or use your oven with just the light on to create a warm environment."
  }
];

export const careGuides = [
  {
    id: 1,
    item: "Banneton Basket & Linen Liner",
    image: "https://images.pexels.com/photos/1571075/pexels-photo-1571075.jpeg",
    care: [
      "After each use, let the basket air dry completely before storing",
      "Remove excess flour by gently tapping the basket upside down",
      "Use the natural brush from your kit to remove stuck dough",
      "Wash linen liner separately in cold water, air dry flat",
      "Never submerge the basket in water - this can cause mold",
      "Store in a dry, well-ventilated area",
      "If mold appears, sun-dry the basket for several hours to kill spores"
    ]
  },
  {
    id: 2,
    item: "Natural Brush",
    image: "https://images.pexels.com/photos/600620/pexels-photo-600620.jpeg",
    care: [
      "Brush is specifically for cleaning your banneton basket",
      "After use, tap brush to remove flour",
      "Rinse bristles under cool water if needed",
      "Hang or store bristles-down to air dry",
      "Replace when bristles become too soft or damaged"
    ]
  },
  {
    id: 3,
    item: "Danish Dough Whisk",
    image: "https://images.unsplash.com/photo-1612136435623-a9bb63231e07?auto=format&fit=crop&w=1200&q=80",
    care: [
      "Rinse immediately after use before dough dries",
      "Use warm soapy water and scrub between wires",
      "Dishwasher safe",
      "Dry thoroughly to prevent rust on metal parts",
      "Wooden handle may benefit from occasional mineral oil treatment"
    ]
  },
  {
    id: 4,
    item: "Bench Scraper & Bowl Scraper",
    image: "https://images.unsplash.com/photo-1654524086749-aa2703ab0784?auto=format&fit=crop&w=1200&q=80",
    care: [
      "Wash with warm soapy water after each use",
      "Scrapers are dishwasher safe",
      "Metal bench scraper should be dried immediately to prevent rust",
      "Store flat to prevent warping of your bench scraper",
      "Keep metal scraper sharp edge away from other tools"
    ]
  },
  {
    id: 5,
    item: "Bread Lame & Replacement Blades",
    image: "https://images.unsplash.com/photo-1613396874083-2d5fbe59ae79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxzb3VyZG91Z2glMjBicmVhZHxlbnwwfHx8fDE3NjY4MjY0NTh8MA&ixlib=rb-4.1.0&q=85",
    care: [
      "Handle with care - blades are extremely sharp",
      "Replace blade when it becomes dull or after 5-10 loaves",
      "Store with blade guard on when not in use",
      "Keep away from children and pets",
      "Dispose of old blades safely in a blade bank or wrapped in cardboard",
      "Wipe handle with damp cloth - do not submerge"
    ]
  },
  {
    id: 6,
    item: "Unbleached Parchment Paper",
    image: "https://images.pexels.com/photos/29251077/pexels-photo-29251077.jpeg",
    care: [
      "Store in a cool, dry place away from heat sources",
      "Can be reused 2-3 times if not heavily soiled",
      "Parchment is oven-safe up to 450°F",
      "Do not use parchment under the broiler",
      "Trim to fit your baking vessel to prevent burning edges",
      "Compostable after use (unbleached parchment only)"
    ]
  }
];

export const gettingStartedSteps = [
  {
    id: 1,
    title: "Creating Your Starter from Scratch",
    duration: "7-14 days",
    description: "Starting a sourdough culture from scratch is a rewarding process that connects you with centuries of baking tradition.",
    steps: [
      {
        day: "Day 1",
        instruction: "Mix 50g whole wheat or rye flour with 50g water in a clean jar. Stir well, cover loosely, and let sit at room temperature (70-75°F)."
      },
      {
        day: "Day 2",
        instruction: "You may see a few bubbles. Add 50g flour and 50g water, stir well. The mixture should be thick but pourable."
      },
      {
        day: "Day 3-7",
        instruction: "Discard half of the starter (about 50g). Add 50g flour and 50g water. Repeat daily. By day 5-7, you should see consistent bubbling and a pleasant sour smell."
      },
      {
        day: "Day 7-14",
        instruction: "Continue daily feedings. Your starter is ready when it reliably doubles in size within 4-12 hours after feeding and has a domed top with lots of bubbles."
      }
    ],
    tips: [
      "Use a clear jar so you can see the bubbles and rise",
      "Mark the starter level with a rubber band to track growth",
      "Whole grain flours ferment faster than white flour",
      "Don't give up! Some starters take the full 14 days"
    ]
  },
  {
    id: 2,
    title: "Reviving a Dormant Starter",
    duration: "3-5 days",
    description: "If your starter has been neglected in the fridge or has become inactive, you can easily bring it back to life.",
    steps: [
      {
        day: "Day 1",
        instruction: "Remove starter from fridge. Discard all but 50g. Add 50g flour and 50g room temperature water. Mix well and leave at room temperature."
      },
      {
        day: "Day 2",
        instruction: "You should see some activity. Discard half and feed again with 50g flour and 50g water. Feed twice daily if possible."
      },
      {
        day: "Day 3-5",
        instruction: "Continue twice-daily feedings. Your starter is revived when it doubles consistently within 4-8 hours after feeding and has a domed top with lots of bubbles."
      }
    ],
    tips: [
      "Even starters left for months can usually be revived",
      "If you see any mold (rare), discard and start fresh",
      "A dark liquid on top (hooch) is normal - just stir it back in",
      "Warmer temperatures (75-80°F) speed up revival"
    ]
  },
  {
    id: 3,
    title: "Maintaining Your Active Starter",
    duration: "Ongoing",
    description: "Once active, your starter becomes a living part of your kitchen that needs regular feeding to stay healthy.",
    steps: [
      {
        day: "Daily Routine",
        instruction: "If keeping at room temperature: Feed once or twice daily with equal parts starter, flour, and water (e.g., 50g each). Discard before feeding unless using in a recipe."
      },
      {
        day: "Weekly Routine",
        instruction: "If storing in fridge: Feed once weekly. Take out, bring to room temperature, discard most of it, feed, let sit 1-2 hours, then refrigerate."
      },
      {
        day: "Before Baking",
        instruction: "Take starter from fridge 12-24 hours before baking. Feed it and let it reach peak activity (doubled in size, domed top, lots of bubbles). Use at peak."
      }
    ],
    tips: [
      "Check readiness: Starter should double in size within 4-8 hours and have a domed top with lots of bubbles",
      "Mark your jar to track doubling",
      "Keep a small amount - you only need 50-100g of maintained starter",
      "Save discard for pancakes, crackers, and other recipes"
    ]
  }
];

export const resources = [
  {
    id: 1,
    title: "Recommendations",
    description: "A few favorites to complement your kit.",
    items: [
      {
        name: "Living Dough Sourdough Starters",
        description: "A friendly way to try an established starter culture if you’d like to compare flavors or keep a backup.",
        url: "https://amzn.to/4rrUUg0",
        type: "ingredient",
        affiliate: true
      }
    ]
  }
];
